import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_KEY = "rentmich_cookie_consent";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-zinc-200 p-6 sm:p-8">
        <div className="flex flex-col sm:flex-row gap-6 items-start">
          {/* Icon */}
          <div className="hidden sm:flex w-12 h-12 bg-orange-100 rounded-xl items-center justify-center flex-shrink-0">
            <Cookie className="h-6 w-6 text-orange-600" />
          </div>

          {/* Content */}
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-zinc-900 mb-2">
              Cookie-Einstellungen
            </h3>
            <p className="text-sm text-zinc-600 leading-relaxed mb-4">
              Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
              Diese helfen uns, die Website-Nutzung zu analysieren und unseren Service zu verbessern. 
              Weitere Informationen finden Sie in unserer{" "}
              <Link 
                to="/datenschutz" 
                className="text-orange-600 hover:underline font-medium"
              >
                Datenschutzerklärung
              </Link>.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={handleAccept}
                className="bg-orange-600 hover:bg-orange-700 text-white"
                data-testid="cookie-accept"
              >
                Alle akzeptieren
              </Button>
              <Button
                onClick={handleDecline}
                variant="outline"
                className="border-zinc-300 text-zinc-700 hover:bg-zinc-100"
                data-testid="cookie-decline"
              >
                Nur notwendige
              </Button>
            </div>
          </div>

          {/* Close button */}
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 sm:relative sm:top-0 sm:right-0 p-2 text-zinc-400 hover:text-zinc-600 transition-colors"
            aria-label="Schließen"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
